import { render, staticRenderFns } from "./ViewHeader.vue?vue&type=template&id=ffeb78b4&scoped=true"
import script from "./ViewHeader.vue?vue&type=script&lang=js"
export * from "./ViewHeader.vue?vue&type=script&lang=js"
import style0 from "./ViewHeader.vue?vue&type=style&index=0&id=ffeb78b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffeb78b4",
  null
  
)

export default component.exports